import { produce } from 'immer';
import { HeatMapSpec } from '@/core';
import { OptionsEditorColumn, OptionsEditorGrid, ResetSettingsButton } from '@/plugin-editor-components';
import {
  DEFAULT_COLOR_OPTIONS,
  DEFAULT_LEGEND_OPTIONS,
  DEFAULT_Y_AXIS_OPTIONS,
  HeatMapOptionsEditorProps,
} from '../heat-map-model';
import { ColorOptionsEditor } from './ColorOptionsEditor';
import { LegendOptionsEditor } from './LegendOptionsEditor';
import { YAxisOptionsEditor, YAxisOptionsEditorProps } from './YAxisOptionsEditor';

export function HeatMapOptionsEditorSettings({ onChange, value }: HeatMapOptionsEditorProps) {
  const handleYAxisChange: YAxisOptionsEditorProps['onChange'] = (newYAxis) => {
    onChange(
      produce(value, (draft: HeatMapSpec) => {
        draft.y_axis = newYAxis;
      })
    );
  };
  return (
    <OptionsEditorGrid>
      <OptionsEditorColumn>
        <LegendOptionsEditor
          value={value.legend ?? DEFAULT_LEGEND_OPTIONS}
          onChange={(newValue) => onChange({ ...value, legend: newValue })}
        />
        <ColorOptionsEditor
          value={value.color ?? DEFAULT_COLOR_OPTIONS}
          onChange={(newValue) => onChange({ ...value, color: newValue })}
        />
      </OptionsEditorColumn>

      <OptionsEditorColumn>
        <YAxisOptionsEditor value={value.y_axis ?? DEFAULT_Y_AXIS_OPTIONS} onChange={handleYAxisChange} />
      </OptionsEditorColumn>
      <OptionsEditorColumn>
        <ResetSettingsButton value={value} onChange={onChange} />
      </OptionsEditorColumn>
    </OptionsEditorGrid>
  );
}
